import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { useGeoRedirect } from './hooks/useGeoRedirect';

function GeoRedirectWrapper() {
  useGeoRedirect();
  return <AppRoutes />;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <GeoRedirectWrapper />
    </BrowserRouter>
  );
}

export default App;
